import React from 'react';

import {Link} from "../../../../core/components/link/link";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";
import classNames from "classnames";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import styles from "../../styles/entity-scores-widget.module.scss";
import {ENTITY_SCORES} from "../../entity-scores-widget.consts";
import {CompetitorLinkModel} from "../../../../containers/competitor-container/models/competitor-link-model";

export class CompetitorScoresWidgetNavigationButtonProps extends BaseProps {
}

export const EntityScoresWidgetNavigationButton = ({
                                                     controller,
                                                     children,
                                                     filterType,
                                                     linkParams,
                                                     onClick
                                                   }: CompetitorScoresWidgetNavigationButtonProps) => {
  const {state} = controller;
  const {entity} = state;

  const onButtonClick = () => {
    controller.action(ENTITY_SCORES.ACTION_HANDLERS.filterChange, {
      entityId: entity?.id,
      entityType: ANALYTICS.ENTITY_TYPES.competitor,
      position: ENTITY_SCORES.FOOTER_POSITION,
      filterType,
    });

    return true;
  }

  const link = new CompetitorLinkModel(entity?.id, entity?.sport.nameForURL, entity?.nameForURL, entity?.isFollow);
  link.replace = true;

  const arrowProps = {
    className: classNames(styles.navigation_button),
    model: link,
    onClick: onClick ? () => onClick() :  () => onButtonClick(),
    shouldScrollToTop: true,
    disable: onClick
  }

  return (
    <Link {...arrowProps}>
      {
        children
      }
    </Link>
  )
}
